module.exports = __webpack_public_path__ + "static/media/27.4f92a1ec.jpg";